<script lang="ts" setup>
const { footer } = useAppConfig()
</script>

<template>
  <UFooter :ui="{ left: 'text-muted text-xs' }">
    <template #left>
      {{ footer.credits }}
    </template>

    <template #right>
      <template v-if="footer?.links">
        <UButton
          v-for="(link, index) of footer?.links"
          :key="index"
          v-bind="{ size: 'xs', color: 'primary', variant: 'link', ...link }"
        />
      </template>
    </template>
  </UFooter>
</template>
